import React, { Fragment } from 'react'
import { Spacer } from 'components/Spacer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

export const Loading = () => <Fragment>
  <Spacer><FontAwesomeIcon icon={faSpinnerThird} spin /></Spacer>Loading...
</Fragment>